import { render, staticRenderFns } from "./related-order.vue?vue&type=template&id=34be06b2&"
import script from "./related-order.vue?vue&type=script&lang=js&"
export * from "./related-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports